import {AbstractValidatable, ValidationErrorsObject} from "frontend-core";

export class AgentToAdd extends AbstractValidatable {
    name: string = "";
    login: string = "";
    email: string = "";
    phone: string = '';
    role: string = "";
    parentAgentId: string = "";
    legacyUserId: number | null = null;

    public errors: ValidationErrorsObject<{
        name: string[],
        login: string[],
        email: string[],
        phone: string[],
        role: string[],
        parentAgentId: string[],
        legacyUserId: string[],
    }> = {
        name: [],
        login: [],
        email: [],
        phone: [],
        role: [],
        parentAgentId: [],
        legacyUserId: [],
    }

    constructor() {
        super();
    }
}
